import React from 'react';

const FooterDesktop = () => {
  return <div style={{ padding: 20, background: '#000', color: '#FFF' }} ><span>Bitte kontaktiere uns bezüglich etwaiger Allergien oder Unverträglichkeiten.</span></div>;
};

export default FooterDesktop;
